<template>
  <div v-if="show" class="center" style="padding: 2em;">
    <div class="loader" :style="{'border-top-color': color}"></div>
  </div>
</template>

<script>
  export default {
    props: {
      color: {
        type: String,
        default: '#bdc3c7'
      },
      timeLoading: {
        type: Number,
        default: 500
      },
    },
    data() {
      return {
        show: true
      }
    },
    mounted () {
      setTimeout(() => {
        this.show = false
      }, this.timeLoading);
    },
  }
</script>

<style lang="scss" scoped>
.loader {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid; 
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>